import { useContext } from "react";
import { Navigate } from "react-router-dom";
import GeneralContext from "../context/GeneralContext/GeneralContext";

import messages from "../services/messages";

const { CANNOT_ACCESS_SCREEN } = messages;


const PermissionedRoute = ({
  permissions,
  children }) => {

  const { user } = useContext(GeneralContext);

  const handleOnValidatePermissions = (permissions) => {

    const userCanAccess = permissions.includes(user.user_type);

    if (!userCanAccess) {
      alert(CANNOT_ACCESS_SCREEN)
    }

    return userCanAccess;
  }

  if (children) {
    if (handleOnValidatePermissions(permissions)) {
      return children
    }
    
    return <Navigate to={'/'} replace />
  }
};

export default PermissionedRoute

